import SongPreview from "./SongPreview.component";

export default SongPreview;
